export default class CategoryPageAnchor {

	constructor(naja) {
		naja.addEventListener('init', this._init.bind(this));
	}

	_init() {
		const currentPath = window.location.pathname;
		if (currentPath.includes('strana=')) {
			const match = (/strana=(\d-)?(\d+)/).exec(currentPath);
			const page = match[2];
			const pageAnchor = document.getElementById(`products-page-${page}`);
			if (pageAnchor) {
				setTimeout(() => {
					pageAnchor.scrollIntoView({
						behavior: 'smooth'
					});
				}, 500);
			}
		}
	}

}

